import { toast } from "react-toastify";
import { FaCopy, FaExpandAlt, FaTimes } from "react-icons/fa";

const VLCVEs = () => {
    const showExample = (show) => {
        document.getElementById(show).classList.remove("hidden");
    };

    const hideExample = (hide) => {
        document.getElementById(hide).classList.add("hidden");
    };

    const copyExample = () => {
        navigator.clipboard.writeText(
            "import requests\r\nurl = 'https://api.feeds.vederelabs.com/feedservice/api/cves/vloriginal'\r\nheaders = {\r\n\t'api-key' : '{your_api_key}'\r\n}\r\nresponse = requests.get(url, headers=headers)\r\nprint(response.text)"
        );
        toast.success("API request has been copied!", {
            position: toast.POSITION.TOP_LEFT,
        });
    };

    return (
        <div className="column">
            <div className="desc-section">
                <h2>Vedere Labs Original CVEs</h2>
                <p>
                    This API query call will enable you to get the list of CVEs originally discovered by Vedere Labs as well as all the software related to it. This call will return a dictionary that has the Vedere Labs' project names as key, and a list of STIX Bundle Objects as value. Each STIX Bundle contains STIX Vulnerability Objects to represent the CVE, as well as STIX Software Observables to represent the CPE related to it , if they exist.
                </p>
            </div>
            <div className="example">
                <div className="codeHeader">
                    <p>API Request (Python)</p>
                    <FaCopy className="icon" onClick={() => copyExample()} />
                </div>
                <div className="code">
                    <p className="codeLine">
                        <span className="highlight">import</span> requests
                    </p>
                    <p className="codeLine">
                        url <span className="highlight">= "</span>
                        <span className="quote">
                            https://api.feeds.vederelabs.com/feedservice/api/cves/vloriginal
                        </span>
                        <span className="highlight">"</span>
                    </p>
                    <p className="codeLine">
                        headers <span className="highlight">= </span> &#123;
                    </p>
                    <p className="codeLine tab">
                        <span className="highlight">'api-key' </span>:
                        <span className="highlight"> '&#123;your_api_key&#125;'</span>
                    </p>
                    <p className="codeLine">&#125;</p>
                    <p className="codeLine">
                        response <span className="highlight">=</span> requests.get(url,
                        headers=headers)
                    </p>
                    <p className="codeLine">
                        <span className="secHighlight">print</span>(response.text)
                    </p>
                </div>
            </div>
            <div className="responses">
                <div className="response" onClick={() => showExample("code1")}>
                    <div className="greenCircle"></div>
                    <p>HTTP code 200 - Successful Response</p>
                    <FaExpandAlt className="expand" />
                </div>
                <div className="code hidden" id="code1">
                    <FaTimes className="close" onClick={() => hideExample("code1")} />
                    <p>&#123;</p>
                    <p className="tab">"type": "bundle",</p>
                    <p className="tab">"id": "bundle--d3f1c8e2-4f9a-4a2e-9b6e-1a2b3c4d5e6f",</p>
                    <p className="tab">"spec_version": "2.1",</p>
                    <p className="tab">"objects": [</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "vulnerability",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
                    <p className="tab3">"created": "2023-12-01T00:00:00Z",</p>
                    <p className="tab3">"modified": "2024-01-15T00:00:00Z",</p>
                    <p className="tab3">"name": "CVE-2023-9999",</p>
                    <p className="tab3">"confidence": 85,</p>
                    <p className="tab3">"description": "Critical remote code execution vulnerability in web application framework. This vulnerability allows unauthenticated attackers to execute arbitrary code on affected systems.",</p>
                    <p className="tab3">"labels": [</p>
                    <p className="tab4">"is_cisa_kev:false",</p>
                    <p className="tab4">"is_vl_kev:true"</p>
                    <p className="tab3">],</p>
                    <p className="tab3">"external_references": [</p>
                    <p className="tab4">&#123;</p>
                    <p className="tab5">"source_name": "cve",</p>
                    <p className="tab5">"external_id": "CVE-2023-9999",</p>
                    <p className="tab5">"url": "https://example.com/?=CVE-2023-9999"</p>
                    <p className="tab4">&#125;</p>
                    <p className="tab3">],</p>
                    <p className="tab3">"x_device_category": ["OT", "IoT"],</p>
                    <p className="tab3">"x_cpes": [</p>
                    <p className="tab4">"cpe:2.3:a:example_vendor:example_product:1.0:*:*:*:*:*:*:*",</p>
                    <p className="tab4">"cpe:2.3:a:example_vendor:example_product:1.1:*:*:*:*:*:*:*"</p>
                    <p className="tab3">],</p>
                    <p className="tab3">"x_kev_published": [</p>
                    <p className="tab4">&#123;</p>
                    <p className="tab5">"name": "CISA",</p>
                    <p className="tab5">"date": "2023-10-10T00:00:00Z"</p>
                    <p className="tab4">&#125;,</p>
                    <p className="tab4">&#123;</p>
                    <p className="tab5">"name": "VL-KEV",</p>
                    <p className="tab5">"date": "2023-11-01T00:00:00Z"</p>
                    <p className="tab4">&#125;</p>
                    <p className="tab3">],</p>
                    <p className="tab3">"x_vulnerability_published": "2023-09-15T00:00:00Z"</p>
                    <p className="tab2">&#125;,</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "sighting",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "sighting--4333aaaa-4444bbbb-5555cccc-6666dddd7777",</p>
                    <p className="tab3">"created": "2024-01-06T00:00:00Z",</p>
                    <p className="tab3">"modified": "2024-01-06T00:00:00Z",</p>
                    <p className="tab3">"sighting_of_ref": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
                    <p className="tab3">"first_seen": "2024-01-02T00:00:00Z",</p>
                    <p className="tab3">"last_seen": "2024-01-05T00:00:00Z",</p>
                    <p className="tab3">"count": 321,</p>
                    <p className="tab3">"where_sighted_refs": [</p>
                    <p className="tab4">"observed-data--aaaa1111-bbbb-2222-cccc-3333dddd4444"</p>
                    <p className="tab3">],</p>
                    <p className="tab3">"x_unique_attacker_ip_counter": 150</p>
                    <p className="tab2">&#125;,</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "course-of-action",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "course-of-action--a1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
                    <p className="tab3">"name": "patch",</p>
                    <p className="tab3">"created": "2024-05-01T00:00:00Z",</p>
                    <p className="tab3">"modified": "2024-05-01T00:00:00Z",</p>
                    <p className="tab3">"external_references": [</p>
                    <p className="tab4">&#123;</p>
                    <p className="tab5">"source_name": "NVD",</p>
                    <p className="tab5">"url": "https://example.com/security-patch"</p>
                    <p className="tab4">&#125;</p>
                    <p className="tab3">],</p>
                    <p className="tab3">"x_published" : "2024-05-01T00:00:00Z"</p>
                    <p className="tab2">&#125;,</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "tool",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "tool--c1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
                    <p className="tab3">"name": "CVE-9999 Scanner for Linux",</p>
                    <p className="tab3">"created": "2025-10-20T10:00:00Z",</p>
                    <p className="tab3">"modified": "2025-10-20T10:00:00Z",</p>
                    <p className="tab3">"external_references": [</p>
                    <p className="tab4">&#123;</p>
                    <p className="tab5">"source_name": "CVE-9999 Scanner for Linux",</p>
                    <p className="tab5">"url": "https://github.com/example/cve-9999-scanner"</p>
                    <p className="tab4">&#125;</p>
                    <p className="tab3">],</p>
                    <p className="tab3">"x_created_date": "2025-10-21T09:00:00Z"</p>
                    <p className="tab2">&#125;,</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "location",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "location--a1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
                    <p className="tab3">"country": "DE",</p>
                    <p className="tab3">"created": "2025-10-20T10:00:00Z",</p>
                    <p className="tab3">"modified": "2025-10-20T10:00:00Z",</p>
                    <p className="tab3">"x_first_seen": "2024-01-01T00:00:00Z",</p>
                    <p className="tab3">"x_count": 42</p>
                    <p className="tab2">&#125;,</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "infrastructure",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "infrastructure--a1a1a1a1-b2b2-c3c3-d4d4-e5e5e5e5e5e5",</p>
                    <p className="tab3">"name": "Infrastructure in Germany",</p>
                    <p className="tab3">"infrastructure_types": ["unknown"],</p>
                    <p className="tab3">"created": "2025-10-31T00:00:00Z",</p>
                    <p className="tab3">"modified": "2025-10-31T00:00:00Z"</p>
                    <p className="tab2">&#125;,</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "relationship",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "relationship--ebcd1234-5678-ijkl-efgh-112233445566",</p>
                    <p className="tab3">"relationship_type": "mitigates",</p>
                    <p className="tab3">"source_ref": "course-of-action--a1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
                    <p className="tab3">"target_ref": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
                    <p className="tab3">"created": "2024-05-01T00:00:00Z",</p>
                    <p className="tab3">"modified": "2024-05-01T00:00:00Z"</p>
                    <p className="tab2">&#125;,</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "relationship",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "relationship--4444aaaa-5555bbbb-6666cccc-7777dddd8888",</p>
                    <p className="tab3">"relationship_type": "targets",</p>
                    <p className="tab3">"source_ref": "tool--c1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
                    <p className="tab3">"target_ref": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
                    <p className="tab3">"created": "2024-06-15T00:00:00Z",</p>
                    <p className="tab3">"modified": "2024-06-15T00:00:00Z"</p>
                    <p className="tab2">&#125;,</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "relationship",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "relationship--5555aaaa-6666bbbb-7777cccc-8888dddd9999",</p>
                    <p className="tab3">"relationship_type": "located-at",</p>
                    <p className="tab3">"source_ref": "infrastructure--a1a1a1a1-b2b2-c3c3-d4d4-e5e5e5e5e5e5",</p>
                    <p className="tab3">"target_ref": "location--a1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
                    <p className="tab3">"created": "2025-11-01T00:00:00Z",</p>
                    <p className="tab3">"modified": "2025-11-01T00:00:00Z"</p>
                    <p className="tab2">&#125;,</p>
                    <p className="tab2">&#123;</p>
                    <p className="tab3">"type": "relationship",</p>
                    <p className="tab3">"spec_version": "2.1",</p>
                    <p className="tab3">"id": "relationship--6666aaaa-7777bbbb-8888cccc-9999dddd0000",</p>
                    <p className="tab3">"relationship_type": "targets",</p>
                    <p className="tab3">"source_ref": "infrastructure--a1a1a1a1-b2b2-c3c3-d4d4-e5e5e5e5e5e5",</p>
                    <p className="tab3">"target_ref": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
                    <p className="tab3">"created": "2025-11-05T00:00:00Z",</p>
                    <p className="tab3">"modified": "2025-11-05T00:00:00Z"</p>
                    <p className="tab2">&#125;</p>
                    <p className="tab">]</p>
                    <p>&#125;</p>
                </div>

                <div className="response" onClick={() => showExample("code2")}>
                    <div className="redCircle"></div>
                    <p>HTTP code 401 - Not authenticated</p>
                    <FaExpandAlt className="expand" />
                </div>
                <div className="code hidden" id="code2">
                    <FaTimes className="close" onClick={() => hideExample("code2")} />
                    <p>&#123;"detail": "Not Authenticated"&#125;</p>
                </div>

                <div className="response" onClick={() => showExample("code3")}>
                    <div className="redCircle"></div>
                    <p>
                        HTTP code 403 - User has not permissions to access the requested
                        resource
                    </p>
                    <FaExpandAlt className="expand" />
                </div>
                <div className="code hidden" id="code3">
                    <FaTimes className="close" onClick={() => hideExample("code3")} />
                    <p>
                        &#123;"detail": "User has not permissions to access the requested
                        resource"&#125;
                    </p>
                </div>

                <div className="response" onClick={() => showExample("code4")}>
                    <div className="redCircle"></div>
                    <p>HTTP code 404 - Resource not found</p>
                    <FaExpandAlt className="expand" />
                </div>
                <div className="code hidden" id="code4">
                    <FaTimes className="close" onClick={() => hideExample("code4")} />
                    <p>&#123;"detail": "Resource not found"&#125;</p>
                </div>

                <div className="response" onClick={() => showExample("code5")}>
                    <div className="redCircle"></div>
                    <p>HTTP code 422 - Validation error</p>
                    <FaExpandAlt className="expand" />
                </div>
                <div className="code hidden" id="code5">
                    <FaTimes className="close" onClick={() => hideExample("code5")} />
                    <p>&#123;"detail": "Validation error"&#125;</p>
                </div>

                <div className="response" onClick={() => showExample("code6")}>
                    <div className="redCircle"></div>
                    <p>HTTP code 500 - Error processing the request</p>
                    <FaExpandAlt className="expand" />
                </div>
                <div className="code hidden" id="code6">
                    <FaTimes className="close" onClick={() => hideExample("code6")} />
                    <p>&#123;"detail": "Not Found"&#125; </p>
                </div>
            </div>
            <p className="field">Response Fields</p>
            <ul className="variables">
                <p className="subfield">STIX Bundle</p>
                <li className="italic">
                    <span className="bold">type:</span>type of the STIX Object, it must be
                    "bundle" in this case
                </li>
                <li className="italic">
                    <span className="bold">id:</span>the ID of the Bundle
                </li>
                <li className="italic">
                    <span className="bold">objects:</span>a list of STIX Objects
                </li>
            </ul>
            <ul className="variables">
                <p className="subfield">STIX Vulnerability Object</p>
                <li className="italic">
                    <span className="bold">type:</span>type of the STIX Object. In this
                    case, it must be "vulnerability"
                </li>
                <li className="italic">
                    <span className="bold">spec_version:</span>the version of the STIX
                    specification used to represent this object. The value of this
                    property must be 2.1
                </li>
                <li className="italic">
                    <span className="bold">id:</span>the ID of the Vulnerability
                </li>
                <li className="italic">
                    <span className="bold">created:</span>the time at which the STIX
                    Vulnerability Object was originally created
                </li>
                <li className="italic">
                    <span className="bold">modified:</span>the time that this particular
                    version of the STIX Object was last modified
                </li>
                <li className="italic">
                    <span className="bold">name:</span>the name used to identify the
                    Vulnerability
                </li>
                <li className="italic">
                    <span className="bold">description:</span>a description that provides
                    more details and context about the Vulnerability
                </li>
                <li className="italic">
                    <span className="bold">labels:</span>list of labels, which includes the project name (i.e. "project=Dray:Break")
                </li>
                <li className="italic">
                    <span className="bold">external_references:</span>a list of dictionaries that includes source_name and url. The source name will always be "Forescout Research - Vedere Labs" and the url will be a link to where the report of the vulnerabilities is published
                </li>
                <li className="italic">
                    <span className="bold">x_CVSSv3.x:</span>CVVSv3 base score (custom
                    property)
                </li>
                <li className="italic">
                    <span className="bold">x_CVSSv3.x_vector:</span>vector of base score
                    metrics (custom property)
                </li>
                <li className="italic">
                    <span className="bold">x_remediation(optional)</span>recommended remediation to combat the vulnerability
                </li>
                <li className="italic">
                    <span className="bold">x_title(optional)</span>the title of the vulnerability
                </li>
                <li className="italic">
                    <span className="bold">x_cpes</span>a list of CPEs associated with this vulnerability
                </li>
                <li className="italic">
                    <span className="bold">x_device_category</span>the category of the device or software associated with this vulnerability (e.g. IT, OT)
                </li>
                <li className="italic">
                    <span className="bold">x_kev_published</span>a list of dictionaries that contain the name of the organization and the date it was added to that organization's KEV catalogue
                </li>
                <li className="italic">
                    <span className="bold">x_vulnerability_published</span>the date the vulnerability was published in the vulnerability database
                </li>
            </ul>
            <ul className="variables">
                <p className="subfield">STIX Software Observable</p>
                <li className="italic">
                    <span className="bold">type:</span>type of the STIX Object. In this
                    case, it must be "software"
                </li>
                <li className="italic">
                    <span className="bold">spec_version:</span>the version of the STIX
                    specification used to represent this object. The value of this
                    property must be 2.1
                </li>
                <li className="italic">
                    <span className="bold">id:</span>the ID of the software
                </li>
                <li className="italic">
                    <span className="bold">name:</span>the name used to identify the
                    software
                </li>
                <li className="italic">
                    <span className="bold">cpe:</span>specifies the Common Platform
                    Enumeration (CPE) entry for the software, if available. The value for
                    this property must be a CPE v2.3 entry from the official NVD CPE
                    Dictionary
                </li>
                <li className="italic">
                    <span className="bold">vendor:</span>specifies the name of the vendor
                    of the software
                </li>
                <li className="italic">
                    <span className="bold">version:</span>specifies the version of the
                    software
                </li>
            </ul>
            <ul className="variables">
                <p className="subfield">STIX Location/Infrastructure Object</p>
                <li className="italic">
                    <span className="bold">type:</span>type of the STIX Object. In this
                    case, it must be "location" or "infrastructure"
                </li>
                <li className="italic">
                    <span className="bold">spec_version:</span>the version of the STIX
                    specification used to represent this object. The value of this
                    property must be 2.1
                </li>
                <li className="italic">
                    <span className="bold">id:</span>the ID of the location/infrastructure object
                </li>
                <li className="italic">
                    <span className="bold">name:</span>either the name of the infrastructure or the full name of the country where this vulnerability was detected
                </li>
                <li className="italic">
                    <span className="bold">created:</span>the date the location/infrastructure object was created
                </li>
                <li className="italic">
                    <span className="bold">modified:</span>the date the location/infrastructure object was modified
                </li>
                <li className="italic">
                    <span className="bold">country:</span>(location object only) the country code where this vulnerability was detected
                </li>
                <li className="italic">
                    <span className="bold">x_count</span>(location object only) the number of times this vulnerability was detected
                </li>
                <li className="italic">
                    <span className="bold">infrastructure_types:</span>(infrastructure object only) a list of the types of infrastructure associated
                </li>
            </ul>
            <ul className="variables">
                <p className="subfield">STIX Course of Action Object</p>
                <li className="italic">
                    <span className="bold">type:</span>type of the STIX Object. In this
                    case, it must be "course-of-action"
                </li>
                <li className="italic">
                    <span className="bold">spec_version:</span>the version of the STIX
                    specification used to represent this object. The value of this
                    property must be 2.1
                </li>
                <li className="italic">
                    <span className="bold">id:</span>the ID of the course of action object
                </li>
                <li className="italic">
                    <span className="bold">name:</span>it must be "patch"
                </li>
                <li className="italic">
                    <span className="bold">created:</span>the date the course of action object was created
                </li>
                <li className="italic">
                    <span className="bold">modified:</span>the date the course of action object was modified
                </li>
                <li className="italic">
                    <span className="bold">external_references:</span>a list of dictionaries that includes source_name and url.
                </li>
            </ul>
            <ul className="variables">
                <p className="subfield">STIX Tool Object</p>
                <li className="italic">
                    <span className="bold">type:</span>type of the STIX Object. In this
                    case, it must be "tool"
                </li>
                <li className="italic">
                    <span className="bold">spec_version:</span>the version of the STIX
                    specification used to represent this object. The value of this
                    property must be 2.1
                </li>
                <li className="italic">
                    <span className="bold">id:</span>the ID of the tool object
                </li>
                <li className="italic">
                    <span className="bold">name:</span>the name of the tool
                </li>
                <li className="italic">
                    <span className="bold">created:</span>the date the tool object was created
                </li>
                <li className="italic">
                    <span className="bold">modified:</span>the date the tool object was modified
                </li>
                <li className="italic">
                    <span className="bold">external_references:</span>a list of dictionaries that includes source_name and url.
                </li>
            </ul>
            <ul className="variables">
                <p className="subfield">STIX Relationship Object</p>
                <li className="italic">
                    <span className="bold">type:</span>type of the STIX Object. In this
                    case, it must be "relationship"
                </li>
                <li className="italic">
                    <span className="bold">spec_version:</span>the version of the STIX
                    specification used to represent this object. The value of this
                    property must be 2.1
                </li>
                <li className="italic">
                    <span className="bold">id:</span>the ID of the relationship
                </li>
                <li className="italic">
                    <span className="bold">created:</span>the time at which the relationship was created
                </li>
                <li className="italic">
                    <span className="bold">modified:</span>the time that this particular version of the STIX Object was last modified
                </li>
                <li className="italic">
                    <span className="bold">relationship_type:</span>defines the relationship between the source_ref and the target_ref. In this case it will be "has" and can be read as "source_ref (software) has target_ref (vulnerability)"
                </li>
                <li className="italic">
                    <span className="bold">source_ref:</span>the source reference of the relationship. In this case it will always be a reference to a Software Object
                </li>
                <li className="italic">
                    <span className="bold">target_ref:</span> the target reference of the relationship. In this case it will always be a reference to a Vulnerability Object
                </li>
            </ul>
            <ul className="variables">
                <p className="subfield">STIX Sighting Object</p>
                <li className="italic">
                    <span className="bold">type:</span>type of the STIX Object. In this
                    case, it must be "sighting"
                </li>
                <li className="italic">
                    <span className="bold">spec_version:</span>the version of the STIX
                    specification used to represent this object. The value of this
                    property must be 2.1
                </li>
                <li className="italic">
                    <span className="bold">id:</span>the ID of the sighting object
                </li>
                <li className="italic">
                    <span className="bold">created:</span>the date the sighting object was created
                </li>
                <li className="italic">
                    <span className="bold">modified:</span>the date the sighting object was modified
                </li>
                <li className="italic">
                    <span className="bold">first_seen:</span>the date and time the vulnerability was first seen
                </li>
                <li className="italic">
                    <span className="bold">last_seen:</span>the date and time the vulnerability was last seen
                </li>
                <li className="italic">
                    <span className="bold">count:</span>the count of detections linked to the exploitation of this vulnerability
                </li>
                <li className="italic">
                    <span className="bold">sighting_of_ref:</span>the ID of the vulnerability being exploited
                </li>
                <li className="italic">
                    <span className="bold">x_unique_attacker_ip_counter:</span>the number of unique IPs seen exploiting this vulnerability
                </li>
            </ul>
            <ul className="variables">
                <p className="subfield">STIX Marking Definition Object</p>
                <li className="italic">
                    <span className="bold">type:</span>type of the STIX Object. In this
                    case, it must be "marking definition"
                </li>
                <li className="italic">
                    <span className="bold">spec_version:</span>the version of the STIX
                    specification used to represent this object. The value of this
                    property must be 2.1
                </li>
                <li className="italic">
                    <span className="bold">id:</span>the ID of the marking definiton
                </li>
                <li className="italic">
                    <span className="bold">created:</span>the date the Marking Definition Object was created
                </li>
                <li className="italic">
                    <span className="bold">definition_type:</span>the type of the definition object. In this case it will always be "tlp"
                </li>
                <li className="italic">
                    <span className="bold">name:</span>the name of the the Marking Definition Object. In this case, it will be "TLP:WHITE"
                </li>
                <li className="italic">
                    <span className="bold">definition:</span> a dictionary with the key always being "tlp" and the value being "white"
                </li>
            </ul>
        </div>
    );
};

export default VLCVEs;